var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandLink = function SvgExpandLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.697 29.697"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_100-expand-1",
    "data-name": "100-expand-1",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M27.222,14.849V27.222H2.475V2.475H14.849V0H2.475A2.482,2.482,0,0,0,0,2.475V27.223A2.482,2.482,0,0,0,2.475,29.7H27.222A2.483,2.483,0,0,0,29.7,27.222V14.849Z",
    fill: "#171926"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(14.848 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M409.6,136.53Z",
    transform: "translate(-394.751 -126.631)",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M218.411,0h-8.662V2.474h5.673L204.8,13.1l1.75,1.75L217.174,4.226V9.9h2.475V1.237A1.236,1.236,0,0,0,218.411,0Z",
    transform: "translate(-204.8)",
    fill: "#171926"
  })))))));
};
export default SvgExpandLink;